import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const MyNavbar = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const links = [
    { to: '/', label: 'About' },
    { to: '/blog', label: 'Blog' },
    { to: '/projects', label: 'Projects' },
    { to: '/resume', label: 'Resume' },
  ];

  const isActiveLink = (to) => {
    if (to === '/') {
      return location.pathname === '/';
    }

    return location.pathname === to || location.pathname.startsWith(`${to}/`);
  };

  return (
    <header className="site-navbar">
      <div className="site-navbar__inner">
        <Link to="/" className="site-navbar__brand">K. Thomas</Link>

        <button
          className="site-navbar__toggle"
          aria-label="Toggle navigation"
          onClick={() => setOpen(!open)}
        >
          <span /><span /><span />
        </button>

        <nav className={`site-navbar__links${open ? ' site-navbar__links--open' : ''}`}>
          {links.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={`site-navbar__link${isActiveLink(to) ? ' site-navbar__link--active' : ''}`}
              onClick={() => setOpen(false)}
            >
              {label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default MyNavbar;
